<template>
  <div>
    <!-- 已出货配送单 -->
    <div class="content">
      <!-- 创建任务 -->
      <div class="storeType">
        <el-button type="success" @click="createTask">{{ $t('message.createTask') }}</el-button>
      </div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
        <!-- 任务类型 -->
        <el-form-item :label="$t('message.taskType') + ':'" prop="type">
          <el-select v-model="ruleForm.type" disabled>
            <el-option v-for="item in options" :key="item.key" :label="item.name" :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 执行人 -->
        <el-form-item :label="$t('message.executor') + ':'" prop="execute_by">
          <el-select v-model="ruleForm.execute_by" clearable filterable>
            <el-option v-for="item in adminList" :key="item.key" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 消息推送人 -->
        <el-form-item :label="$t('message.messageRecipient') + ':'">
          <el-select v-model="ruleForm.msg_receive" multiple clearable filterable>
            <el-option v-for="(item, index) in adminList" :key="index" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 任务截止时间 -->
        <el-form-item :label="$t('message.taskDeadline') + ':'" prop="end_at">
          <el-date-picker v-model="ruleForm.end_at" type="datetime" default-time="['20:00:00']"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <!-- 具体抽查要求：-->
        <el-form-item :label="$t('message.specificSpotCheckRequirements') + ':'" prop="desc">
          <div class="specificSpotCheckRequirements">
            <!-- 从系统选择抽查内容-->
            <el-button type="primary" @click="specificSpotCheckRequirements">{{
              $t('message.selectSpotCheckContentFromSystem') }}</el-button>
            <!-- 手动添加 -->
            <el-button type="primary" @click="manuallyAdd">{{ $t('message.manuallyAdd') }}</el-button>
            <div class="table">
              <ol>
                <li>NO</li>
                <!-- 具体要求 -->
                <li class="flex3">{{ $t('message.specificRequirements') }}</li>
                <!-- 操作 -->
                <li>{{ $t('message.operation') }}</li>
              </ol>
              <ul v-for="(item, index) in ruleForm.desc" :key="index">
                <li>{{ index + 1 }}</li>
                <!-- 具体要求 -->
                <li class="flex3">{{ item }}</li>
                <!-- 操作 -->
                <li>
                  <el-button type="primary" @click="ruleForm.desc.splice(index, 1)">
                    {{ $t('message.delete') }}
                  </el-button>
                </li>
              </ul>
            </div>
          </div>
        </el-form-item>
        <!-- *抽查项目选择： -->
        <el-form-item :label="$t('message.spotCheckItemSelection') + ':'" prop="spot_detail">
          <div class="spotCheckItemSelection">
            <!-- 从系统选择抽查内容-->
            <el-button type="primary" @click="spotCheckItemSelection">{{ $t('message.selectSpotCheckContentFromSystem')
            }}</el-button>
            <div class="table" style="width: 500px;">
              <ol>
                <!-- 配送单号 -->
                <li class="flex2">{{ $t('message.porderNumber') }}</li>
                <!-- 操作 -->
                <li>{{ $t('message.operation') }}</li>
              </ol>
              <ul v-for="(item, index) in ruleForm.spot_detail" :key="index">
                <!-- 订单号 -->
                <li class="flex2">
                  <router-link :to="'/orderPorder?order_sn=' + item.porder_sn" target="_blank" class="a-link">
                    {{ item.porder_sn }}
                  </router-link>
                </li>
                <!-- 操作 -->
                <li>
                  <el-button type="primary" @click="ruleForm.spot_detail.splice(index, 1)"> {{ $t('message.delete')
                  }}</el-button>
                </li>
              </ul>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <!-- 从系统选择抽查内容 -->
    <specificRequirementsSelection ref="specificRequirementsSelection" :typeName="typeName" :taskType="taskType" />
    <!-- 手动添加要求 -->
    <manuallyAddRequirements ref="manuallyAddRequirements" />
    <!-- 待出货包裹 抽查项目选择：-->
    <el-dialog :title="$t('message.spotCheckItemSelection')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="580px" center>
      <div class="content">
        <div class="row">
          <div class="search">
            <!--    配送单号  -->
            {{ $t('message.porderNumber') }}：
            <div class="item"> <el-input v-model="porder_sn"></el-input></div>
            <!-- 加入任务 -->
            <el-button type="primary" @click="addSpotDetail">{{ $t('message.addToTask') }}</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import specificRequirementsSelection from '../specificRequirementsSelection'
import manuallyAddRequirements from '../manuallyAddRequirements'
import spotDetailOptionType from './spotDetailOptionType/arrival'
import { lastFewDays } from '@/utlis/date'
export default {
  props: {
    taskType: { type: [Number, String] },
    options: { type: Array },
    adminList: { type: Array },
    executeTypeList: { type: Array },
  },
  components: {
    specificRequirementsSelection,
    manuallyAddRequirements,
    spotDetailOptionType
  },
  data() {
    return {
      typeName: '',// 类型名称
      rules: {
        type: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        end_at: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        execute_by: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "change",
        },],
        msg_receive: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        desc: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        spot_detail: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
      },
      ruleForm: {
        type: this.taskType - 0,
        spot_sn: '',
        execute_by: '',
        end_at: lastFewDays(new (Date), 3),
        msg_receive: [],
        desc: [],
        spot_detail: [],

      },
      dialogVisible: false,
      porder_sn: '',
    };
  },
  methods: {
    // 具体抽查要求 从系统选择抽查内容
    specificSpotCheckRequirements() {
      this.typeName = this.options.find(item => item.key == this.taskType).name
      this.$refs.specificRequirementsSelection.expectList()
    },
    //手动添加
    manuallyAdd() {
      this.$refs.manuallyAddRequirements.dialogVisible = true
      this.$refs.manuallyAddRequirements.content = ''
    },
    //加入任务
    addToTask(list) {
      list.forEach(item => {
        this.ruleForm.desc.push(item.desc)
      })
      this.ruleForm.desc = [...new Set(this.ruleForm.desc)];
      this.$refs.ruleForm.validate(valid => { })

      this.$forceUpdate()
    },
    //抽查项目选择：
    spotCheckItemSelection() {
      this.porder_sn = ''
      this.dialogVisible = true
    },
    // 加入抽查项目
    addSpotDetail() {
      this.ruleForm.spot_detail.push({
        porder_sn: this.porder_sn,
        num: 0,
      })
      var hash = {};
      this.ruleForm.spot_detail = this.ruleForm.spot_detail.reduce(function (item, next) {
        hash[next.porder_sn]
          ? ""
          : (hash[next.porder_sn] = true && item.push(next));
        return item;
      }, []);
      this.dialogVisible = false
      this.$refs.ruleForm.validate(valid => { })
      this.$forceUpdate()
    },
    // 创建任务
    createTask() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          // 获取新单号
          this.$api.spotCheckApi.getNewSpotSn({ type: this.taskType }).then(res => {
            this.ruleForm.spot_sn = res.data.spot_sn
            // 新建任务
            this.$api.spotCheckApi.storeType8(this.ruleForm).then(res => {
              this.$message.success(res.msg)
              this.$parent.$parent.isCreate = false
              this.$parent.$parent.spotList()
            });
          });
        }
      })
    },
  }
}
</script>
<style lang='scss' scoped>
.content {
  position: relative;

  .storeType {
    position: absolute;
    top: 0px;
    right: 0px;
    z-index: 9;
  }

  /deep/.el-form-item {
    margin-bottom: 30px;
  }

  .table {
    margin-top: 20px;

    ol {
      height: 50px;
    }

    ul {
      background-color: #fff;
      padding: 20px 0;
    }

    .flex3 {
      flex: 3;
    }

    .flex2 {
      flex: 2;
    }

  }

  .specificSpotCheckRequirements {
    .table {
      width: 772px;
    }
  }

}

.row {
  display: flex;
  margin: 20px;
  justify-content: space-between;

  .search {
    display: flex;
    line-height: 40px;

    .item {
      margin-right: 20px;
      width: 300px;
    }
  }
}
</style>